import { makeKTBlock, makeSwal } from './functions';
import { BASE_URL } from './variables';

const fetchSchoolData = function (el) {
  const $curEl = $(el);

  $('#modalDetailActivity').modal('show');

  $('#modalDetailActivity #futureFUCard').hide();

  $('#modalDetailActivity [name="editCalendarID"]').val($curEl.attr('data-id'));
  makeKTBlock('#modalDetailActivity form');

  $.post(`${BASE_URL}Activities/getActivityDetails`, {
    type: 'SCHOOL',
    id: $curEl.attr('data-id'),
  })
    .done((resp) => {
      if (resp.code != 200) {
        makeKTBlock('#modalDetailActivity form', 'hide');
        makeSwal('Unknown Error has Occured! Please try again!', null, 'error', null, '375px', null, false);
        return;
      }

      $('#modalDetailActivity .activity-row').remove();
      $('#modalDetailActivity .modal-body').html(resp.page);
      $('#modalDetailActivity [name="curDescription"]').attr('readonly', true);

      const curResp = resp.data;
      $('#buttonsave, #editStatusHolder').show();
      $('#modalDetailActivity [name="curDescription"]').attr('readonly', false);

      if (curResp.STATUS == 'COMPLETED') {
        $('#buttonsave, #editStatusHolder').hide();
        $('#modalDetailActivity [name="curDescription"]').attr('readonly', true);
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', true).attr('readonly', true).prop('checked', true);
      } else {
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', false).prop('checked', false);
      }

      if (curResp.UNIVERSITY_ID) {
        $('#universityRelatedHolder').show();
      } else {
        $('#universityRelatedHolder').hide();
      }

      makeKTBlock('#modalDetailActivity form', 'hide');
    })
    .fail((err) => {
      console.log('Error', err);
      KTApp.unblock('#modalDetailActivity');

      Swal.fire({
        html: 'Invalid ID! Please try again',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });
};

export { fetchSchoolData };
